module.exports = __webpack_public_path__ + "img/P60-en.1b9d9b33.png";